import React from 'react';

export default function AdminPageHeader({ title, actions, filters }) {
  return (
    <div>
      <div className="flex justify-between items-center mb-3">
        <h1 className="text-xl font-semibold">{title}</h1>
        <div className="flex items-center gap-2">{actions}</div>
      </div>
      {filters && (
        <div className="flex flex-wrap justify-between items-center gap-3 mb-3">
          {filters}
        </div>
      )}
    </div>
  );
}
